<template>
    <div>
        <b-button-group>
            <b-button class="filter-button" v-b-modal.filter-modal :variant="numSelectedFilters ? 'light-turquoise' : 'primary'" aria-label="Filter"><i class="fas fa-filter mr-2"></i>
                Filter
                <span v-if="numSelectedFilters">({{ this.numSelectedFilters }})</span>
            </b-button>
            <b-button class="remove-filters"  :variant="numSelectedFilters ? 'light-turquoise' : 'primary'" v-if="numSelectedFilters" @click="handleClear"><i class="fas fa-times"></i></b-button>
        </b-button-group>
        <b-modal id="filter-modal" title="Filter" size="xl" @ok="handleOk" @hide="onHide" ok-title="Använd" cancel-title="Avbryt">
            <div class="row">
                <div class="col-12 col-md-4">
                    <h6 class="filter-title">Ämneskategorier</h6>
                    <b-form-checkbox-group
                            id="categories"
                            v-model="selectedFilters.categories"
                            :options="options.categories"
                            name="categories"
                            value-field="value"
                            text-field="display"
                            stacked
                    ></b-form-checkbox-group>
                </div>
                <div class="col-12 col-md-4">
                    <h6 class="filter-title">Innehållstyp</h6>
                    <b-form-checkbox-group
                            id="contentTypes"
                            v-model="selectedFilters.contentTypes"
                            :options="options.contentTypes"
                            name="contentTypes"
                            value-field="value"
                            text-field="display"
                            stacked
                    ></b-form-checkbox-group>
                    <h6 class="filter-title mt-3">Källkategori</h6>
                    <b-form-checkbox-group
                            id="sourceCategories"
                            v-model="selectedFilters.sourceCategories"
                            :options="options.sourceCategories"
                            name="sourceCategories"
                            value-field="value"
                            text-field="display"
                            stacked
                    ></b-form-checkbox-group>
                </div>
                <div class="col-12 col-md-4">
                    <h6 class="filter-title">Tidsperiod</h6>
                    <b-form-radio-group
                            id="timePeriods"
                            v-model="selectedFilters.timePeriods"
                            :options="options.timePeriods"
                            name="timePeriods"
                            value-field="value"
                            text-field="display"
                            stacked
                    ></b-form-radio-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
/* global Bus */
import { mapState } from 'vuex'

export default {
  props: ['options', 'placeholder'],

  data () {
    return {
      selectedFilters: {
        categories: [],
        sourceCategories: [],
        contentTypes: [],
        timePeriods: []
      }
    }
  },

  mounted () {
    this.selectedFilters = { ...this.selected }
  },

  methods: {
    onHide: function () {
      this.selectedFilters = { ...this.selected }
    },
    handleOk: function () {
      this.setSelected()
      // Bus.$emit('do-perform-search')
    },
    handleClear: function () {
      this.selectedFilters = {
        categories: [],
        sourceCategories: [],
        contentTypes: [],
        timePeriods: []
      }
      this.setSelected()
      // Bus.$emit('do-perform-search')
    },
    setSelected: function () {
      this.$store.commit('setFilters', this.selectedFilters)
      // Bus.$emit('do-perform-search')
    }
  },

  watch: {
    selected: function () {
      this.selectedFilters = { ...this.selected }
    }
  },

  computed: mapState({
    selected: state => state.search.filtered,
    numSelectedFilters: function () {
      return _.size(_.flatMap(this.selectedFilters, filter => filter))
    }
  })
}
</script>
